(function() {
    $(document).ready(function() {
        const oLoginInfoPopup = $('.js24LoginInfoPopup');

        if (!oLoginInfoPopup.length) {
            return;
        }

        oLoginInfoPopup.stop().fadeIn(1000);

        setTimeout(function() {
            oLoginInfoPopup.remove();
        }, 10000);

        function checkForCustomerMenu() {
            if ($('.c24-customer.open').length) {
                oLoginInfoPopup.remove();
                return;
            }
            if ($('.js24LoginInfoPopup').length) {
                setTimeout(function() {
                    checkForCustomerMenu();
                }, 100);
            }
        }

        checkForCustomerMenu();
    });
})();
